import { StatusFormatter } from '@components'

import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { QuoteInvoiceState } from '../../../../../../enums/quoteInvoiceState'
import { QuoteListFilter } from '../../../../../../enums/quoteListFilter'
import { SalesDocumentDeliveryStatus } from '../../../../../../enums/salesDocumentDeliveryStatus'
import { DeliveryStatusIndicator } from '../../../../../DeliveryStatusIndicator'
import { quoteRowStatusToStatusFormatterVariant } from '../../../../constants/quoteRowStatusToStatusFormatterVariant'
import { quoteRowStatusToTitleKey } from '../../../../constants/quoteRowStatusToTitleKey'
import { QuoteRowStatus } from '../../../../types/quoteRowStatus'
import { QuoteInvoicedStatusDot } from './elements/QuoteInvoicedStatusDot'

interface QuoteStatusProps {
  deliveryStatus?: SalesDocumentDeliveryStatus | null
  invoiceState?: QuoteInvoiceState
  status: QuoteRowStatus
}

export const QuoteStatus = ({ deliveryStatus, invoiceState, status }: QuoteStatusProps): ReactElement => {
  const { t } = useTranslation()

  const variant = quoteRowStatusToStatusFormatterVariant[status]
  const title = quoteRowStatusToTitleKey[status]

  // `status` (from `status.status`) is the only field BE's own summary counts agree on — invoiceState
  // never reassigns the bucket, it only picks the dot's look once the row is already Invoiced.
  const isInvoicedBucket = status === QuoteListFilter.Invoiced
  const invoicedStatusDotLabel =
    invoiceState === QuoteInvoiceState.PartiallyInvoiced ? t('quotes.table.status.partly_invoiced') : t(title)

  return (
    <Flex alignItems="center" gap={Spacing.S16} width="fit-content">
      {isInvoicedBucket ? (
        <QuoteInvoicedStatusDot invoiceState={invoiceState} label={invoicedStatusDotLabel} />
      ) : (
        <StatusFormatter title={t(title)} variant={variant} />
      )}
      {deliveryStatus === SalesDocumentDeliveryStatus.Sent && (
        <DeliveryStatusIndicator label={t('quotes.table.status.delivery_indicator.sent.tooltip')} />
      )}
    </Flex>
  )
}
